import type { RequestInfo } from '@ember-data/request';
import { buildBaseURL, type QueryUrlOptions } from '@warp-drive/utilities';
import { SkipCache } from '@warp-drive/core-types/request';

/**
 * Request Builders for Manual Enrollment
 */

export interface EnrollmentData {
  firstName: string;
  lastName: string;
  registrationEmail: string;
  employeeInviteCode: string | null;
  password: string;
  phoneNumber: string | null;
  conditionsAccepted: (string | number)[];
  persistName?: boolean;
}

/**
 * Enroll a new employee
 */
export function enrollUserRequest(data: EnrollmentData): RequestInfo {
  const urlOptions: QueryUrlOptions = {
    identifier: { type: 'logins' },
    op: 'query',
    resourcePath: 'enroll',
  };
  const url = buildBaseURL(urlOptions);

  return {
    url,
    method: 'POST',
    body: JSON.stringify(data),
    cacheOptions: { [SkipCache]: true },
  };
}

/**
 * Enroll a new family member
 */
export function enrollFamilyMemberRequest(data: EnrollmentData): RequestInfo {
  const urlOptions: QueryUrlOptions = {
    identifier: { type: 'logins' },
    op: 'query',
    resourcePath: 'enroll/enroll-family-member',
  };
  const url = buildBaseURL(urlOptions);

  return {
    url,
    method: 'POST',
    body: JSON.stringify(data),
    cacheOptions: { [SkipCache]: true },
  };
}
